/** Адреса ведомости доставки Resource.Receipts (RP-OWN8/OWN9). Литерал `/api/` — только здесь. */
export const OWN_DELIVERY_URLS = {
  /** `GET ?openOnly=`: что требует человека по кассовым агентам ресурса; право `receipts.read` на ресурсе. */
  attention: (resourceId: string) => `/api/receipts/v1/resources/${encodeURIComponent(resourceId)}/agent/attention`,
} as const
